import Highcharts from 'highcharts/highstock';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Auth from '../../../shared/Auth';
import { chartBlue, chartRed, chartYellow } from '../../../shared/config';
import CustomLineChart from '../../Custom/CustomLineChart';
import ChartLoader from '../../Loaders/ChartLoader';
import axios from '../../../utils/axiosClient';

require('highcharts/modules/drag-panes')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

class ReactivePower extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialize: true,
      options: {},
      width: 0,
    };
    this.chart = null;
  }

  componentDidMount() {
    this.fetchData(this.props.deviceId, 1); //1 number of months
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId) {
      this.setState({ initialize: true });
      this.fetchData(nextProps.deviceId, 1); //1 number of months
    }
  }

  async fetchData(deviceId, numberOfMonths) {
    const checkToken = await Auth();
    if (checkToken) {
      const url = `report/reactivepwrvstime/${deviceId}/${numberOfMonths}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data.statusCode === 200) {
            this.drawChart(response.data.result, deviceId, numberOfMonths);
          } else {
            this.drawChart([], deviceId, numberOfMonths);
          }
        })
        .catch((error) => {
          console.log(error);
          this.drawChart([], deviceId, numberOfMonths);
        });
    }
  }

  drawChart(dataObj, deviceId, numberOfMonths) {
    const _self = this;
    const currentR = [];
    const currentY = [];
    const currentB = [];
    let units = '';
    if (Object.keys(dataObj).length > 0) {
      const data = dataObj.reactivePowervsTimeData;
      units = dataObj.units.ReactivePwrUnit;
      data.map((ele) => {
        const tmstmp = Date.parse(ele.reportedTime.replace('T', ' '));
        currentR.push([tmstmp, parseFloat(ele.reactivePower1)]);
        currentY.push([tmstmp, parseFloat(ele.reactivePower2)]);
        currentB.push([tmstmp, parseFloat(ele.reactivePower3)]);
        return true;
      });
    }

    const obj = {
      title: 'Reactive Power Profile',
      unit: `Reactive Power (${units})`,
      selected: numberOfMonths === 1 ? 0 : 3,
      series: [
        {
          name: 'Reactive Power - R',
          color: chartRed,
          data: currentR,
        },
        {
          name: 'Reactive Power - Y',
          color: chartYellow,
          data: currentY,
        },
        {
          name: 'Reactive Power - B',
          color: chartBlue,
          data: currentB,
        },
      ],
      evnt: () =>
        _self.setState({ initialize: true }, () =>
          _self.fetchData(deviceId, 6)
        ),
    };

    this.setState({
      options: obj,
      initialize: false,
    });
  }

  render() {
    const { options } = this.state;

    return (
      <div>
        {this.state.initialize ? (
          <ChartLoader height="150" width="600" />
        ) : (
          <CustomLineChart options={options} />
        )}
      </div>
    );
  }
}
ReactivePower.propTypes = {
  deviceId: PropTypes.string.isRequired,
};

export default ReactivePower;
